//export default class CardUI extends Phaser.GameObjects.Sprite {
//Many modern browsers now support ES6 modules. As long as you import your scripts (including the entrypoint to your application) using <script type="module" src="..."> it will work.
//https://stackoverflow.com/questions/41722621/es6-modules-in-the-browser-uncaught-syntaxerror-unexpected-token-import
import { GameObjects } from 'phaser';
export default class CardUI extends GameObjects.Sprite {
    constructor(scene, x, y, imgId, particles) {
        super(scene, x, y, 'cards', imgId.toUpperCase() + ".png");
        
        //2-15-2024 - removed particles to test if this is causing the crashes on older devices.
        //It uses a shader and GPU and may be causing the crashes.
        //12-9-2024 - added particles back in
        

        this.particles = scene.add.particles(0, 0, 'fire_particle',
            {
                speed: { min: 100, max: 200 },
                angle: { min: 85, max: 95 },
                scale: { start: 0.5, end: 1, ease: 'xBack.easeOut' },
                alpha: { start: 1, end: 0, ease: 'xQuart.easeOut' },
                blendMode: 'ADD',
                accelerationY: 700,
                lifespan: 500,
                frequency: 100,
                maxParticles: 20,
            });
        this.particles.setDepth(1);
    }
    update() {
        if (this.particles) {
            if (this.dragging && this.onFire) {
                this.particles.start();
                this.particles.startFollow(this, 50, 100);
            } else {
                
                this.particles.stop();
            }
        } 

    }
}